import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';
import {
  ApplicationName,
  FormNavigation,
  ControlInputGroup
} from 'components/CASAForm';
import {
  AuSelect,
  AuDirectionLink
} from 'components/DTA';
import { Loader } from 'components/common';
import { FormContext } from 'contexts';
import { ArnContext } from 'contexts';
import { useFormikContext } from 'formik';
import { ArnApplicationFormData } from 'types/forms/arnApplicationTypes';
import { FORM_VALIDATION_ERROR_ALERT, TITLES } from 'arnConstants';

const PersonalDetailsMyGov: React.FC = () => {
  const { validateForm } = useFormikContext<ArnApplicationFormData>();
  const { setFormAlert, openStepById, setOnChangeValidation } = useContext(FormContext);
  const { referenceDataResponse: countryListResponse } = useContext(ArnContext);
  const history = useHistory();

  const handleNext = async () => {
    const validationErrors = await validateForm();
    if (!validationErrors || isEmpty(validationErrors)) {
      setFormAlert(null);
      setOnChangeValidation(false);
      openStepById('AddressAndContact');
    }
    else {
      setFormAlert(FORM_VALIDATION_ERROR_ALERT);
      setOnChangeValidation(true);
    }
  };

  const handleBack = () => {
    history.goBack();
  };

  //TODO: filtering will not be required once this is implemented in new API endpoint
  // remove duplication and then sort alphabetically
  const nationality = countryListResponse?.value && countryListResponse?.value['NATIONALITY']
    .map(nationality => {
      return {
        name: nationality.casa_name
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name))
    .filter((nationality, index, self) =>
      index === self.findIndex(value => value.name === nationality.name)
    );

  if (!nationality || nationality.length <= 0) {
    return <Loader message='Working. Please wait.....' />;
  }

  return (
    <>
      <ApplicationName name='Personal details' />
      <AuDirectionLink
        onClick={handleBack}
        text="Back"
        direction="left" />
      <AuSelect
        name='title'
        label='Title'
        block
        options={[
          {
            text: 'Please select',
            value: ''
          },
          ...TITLES.map(title => {
            return {
              text: title,
              value: title
            };
          })
        ]} />
      <ControlInputGroup
        name='sex'
        label='Sex'
        hintText='We require information on an applicant&apos;s sex to inform medical questionnaires as part of flight crew licence applications'
        type='radio'
        block
        options={[
          {
            label: 'Male',
            value: 'male',
            id: 'radio-personalDetails-sex-male'
          },
          {
            label: 'Female',
            value: 'female',
            id: 'radio-personalDetails-sex-female'
          },
          {
            label: 'Other',
            value: 'other',
            id: 'radio-personalDetails-sex-other'
          }
        ]}
      />
      {
        nationality && nationality.length > 0 && <AuSelect
          name={'nationality'}
          label='Nationality'
          block
          options={[
            ...nationality.map((nationality: { name: string; }) => {
              return {
                text: nationality.name,
                value: nationality.name
              };
            })
          ]}
        />
      }
      <FormNavigation
        nextButtonText='Next'
        onNextAction={handleNext}
        hidePrevious
        showSaveAndExit={false} />
    </>
  );
};

export default PersonalDetailsMyGov;